import { CmykBar, RulerStrip } from "../Marks";
import { scrollToId } from "../../lib/brand";

const NAV = [
  { label: "What We Do", id: "what-we-do" },
  { label: "Our Work", id: "our-work" },
  { label: "Production Art", id: "what-we-do" },
  { label: "Apparel", id: "what-we-do" },
  { label: "Contact", id: "inquiry" },
];

const PLACEHOLDERS = ["Instagram", "Facebook", "Email", "Online Shop"];

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative overflow-hidden bg-[#0a0a0a] px-5 pb-10 pt-20 sm:px-8"
  >
    <CmykBar className="absolute inset-x-0 top-0" />
    <div className="mx-auto max-w-[1600px]">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="display-xl text-[10vw] leading-[0.85] sm:text-[6vw] lg:text-[3.4vw]">
            NO GLYPH STUDIOS
          </p>
          <p className="mt-3 font-display text-lg font-bold italic text-[#0055ff] sm:text-xl">
            Filling the void with independent art.
          </p>
        </div>

        <nav aria-label="Footer" className="lg:col-span-3">
          <p className="label-mono text-neutral-600">SITE</p>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.label}>
                <button
                  data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={() => scrollToId(n.id)}
                  className="link-swipe font-display text-lg font-bold uppercase tracking-tight text-neutral-400 transition-colors hover:text-white"
                >
                  {n.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div className="lg:col-span-4">
          <p className="label-mono text-neutral-600">COMING SOON</p>
          <ul className="mt-5 space-y-3">
            {PLACEHOLDERS.map((p) => (
              <li
                key={p}
                data-testid={`footer-placeholder-${p.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-center justify-between border-b border-[#1c1c1c] pb-2"
              >
                <span className="font-display text-lg font-bold uppercase tracking-tight text-neutral-500">
                  {p}
                </span>
                <span className="font-mono-tech text-[0.6rem] uppercase tracking-[0.2em] text-neutral-700">
                  TBA
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <RulerStrip className="mt-16" color="#1f1f1f" />

      <div className="flex flex-col gap-3 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono-tech text-[0.6rem] uppercase tracking-[0.2em] text-neutral-600">
          © {new Date().getFullYear()} No Glyph Studios. All rights reserved.
        </p>
        <p className="font-mono-tech text-[0.6rem] uppercase tracking-[0.2em] text-neutral-700">
          ART → PRODUCTION → MERCHANDISE
        </p>
      </div>
    </div>
  </footer>
);
